export const submitDelay = 0;

export const displayLimit = 20;
export const pageRangeDisplayed = 5;
export const marginPagesDisplayed = 2;
